/**
 * Created by JurY on 30/05/16.
 */

angular.module("screensApp")

  .controller("PrematchController", function ($scope, $rootScope) {

    $rootScope.isPrematchStatistic = false;
    $rootScope.progressIds = ["empty-pie", "quarter-pie", "half-pie", "threeQuartes-pie", "full-pie"];

    /**
     * @param eventID
     * @returns {boolean}
     */
    $rootScope.loadPrematchAnalysis = function (data) {
      if (!data) return false;

      $rootScope.isPrematchStatistic = false;
      $rootScope.actualAnalysis = null;
      $rootScope.overUnderDataRaw = null;

      // ZOBRAZI ANALYZU - STATISTIKY SA ZOBRAZIA NA SPORTBOXAPP, STATISTIKY V SCREENS APP SU VYRADENE
      if ($rootScope.config.Country) {
        $rootScope.loadAnalysisData(data).then(function (analysisResult) {
          $rootScope.prematchH2hCrossWay(data);
          $rootScope.hideTeamAnalysis();
        });
      } else {
        $rootScope.prematchH2hCrossWay(data);
      }
    };

    	// Hide PrematchContainer
    $rootScope.hidePrematchContainer = function() {
    	$rootScope.settings.prematch.show = false;
    }

    $rootScope.prematchH2hCrossWay = function (data) {
      // h2h and analysis
      if ($rootScope.isPrematchStatistic && $rootScope.actualAnalysis) {
        $rootScope.actualAnalysis.isAnalyzeAndH2h = true;
        $rootScope.initView();
      }
      // analysis
      else if (!$rootScope.isPrematchStatistic && $rootScope.actualAnalysis) {
        $rootScope.actualAnalysis.isAnalyzeAndH2h = false;
        $rootScope.initView();
      } else {
        $rootScope.hidePrematchContainer();
      }
    };
  });
